import { recaptchaRegistry } from './recaptchaRegistry';
import { BUILTIN_ACTIONS } from './utils/constants';
import type { RequestMatchContext } from './utils/types';

/**
 * Register default protected endpoints
 * Called by attachRecaptchaInterceptor before first use
 *
 * TODO: Enable reCAPTCHA protection for additional endpoints when ready:
 * - /auth/register (user registration)
 * - /auth/registerWithPassword (password registration)
 * - /cart (cart operations)
 * - /wishlist (wishlist operations)
 *
 * Currently /auth/checkEmail and /auth/login are protected.
 * Other endpoints will be enabled after backend reCAPTCHA verification is implemented.
 */
export function initializeDefaultEndpoints(): void {
  recaptchaRegistry
    .endpoint('/auth/checkEmail')
    .action(BUILTIN_ACTIONS.CHECK_EMAIL)
    .methods('POST')
    .domain('auth')
    .description('Check if email is registered')
    .register();

  recaptchaRegistry
    .endpoint('/auth/login')
    .action(BUILTIN_ACTIONS.LOGIN_PASSWORD)
    .methods('POST')
    .domain('auth')
    .description('Password login (brute-force / credential-stuffing protection)')
    .register();

  recaptchaRegistry
    .endpoint('/personalization/event')
    .action(BUILTIN_ACTIONS.BROWSING_EVENT)
    .methods('POST')
    .domain('personalization')
    .description('Track browsing event for rewards')
    .when(({ body }) => body?.eventType === 'Browsing')
    .register();
}
